<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName || userData.username }}
        </p>
        <span class="user-status">{{ userData.user_type }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.fullName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'Profile'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Profil</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Oturum Kapat</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: this.getSecureUserData(),
      avatarText,
    }
  },
  methods: {
    // Güvenli userData okuma
    getSecureUserData() {
      try {
        const userData = localStorage.getItem('userData')
        if (!userData || userData === 'undefined' || userData === 'null') {
          return null
        }
        return JSON.parse(userData)
      } catch (error) {
        console.error('Error parsing user data:', error)
        return null
      }
    },
    
    // Güvenli logout işlemi
    logout() {
      try {
        // Tüm localStorage verilerini temizle
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
        localStorage.removeItem('userData')
        localStorage.removeItem('downloadToken')
        localStorage.removeItem('licenceKey')
        localStorage.removeItem('branchData')

        // Ability'yi güvenli şekilde sıfırla
        this.$ability.update(initialAbility)

        // Login sayfasına yönlendir
        this.$router.push({ name: 'auth-login' })
      } catch (error) {
        console.error('Error during logout:', error)
        // Hata olsa bile login sayfasına yönlendir
        this.$router.push({ name: 'auth-login' })
      }
    },
  },
}
</script>
